import React from 'react';
import { ShieldCheck, ChevronDown } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function GuaranteeFAQSection() {
  const faqs = [{
    q: '¿Es un libro físico o digital?',
    a: 'Es un ebook digital de acceso inmediato.'
  }, {
    q: '¿Cómo recibiré el material?',
    a: 'Recibirás acceso automático inmediatamente después de completar tu compra.'
  }, {
    q: '¿Los bonos están incluidos?',
    a: 'Sí. Los 5 bonos están incluidos sin costo adicional.'
  }, {
    q: '¿Necesito experiencia previa?',
    a: 'No. Todo el contenido está diseñado para cualquier mujer que quiera fortalecer su autoestima y amor propio.'
  }, {
    q: '¿Cuánto tiempo tendré acceso?',
    a: 'El acceso es para siempre.'
  }];
  return <section className="w-full bg-brand-cream py-16 md:py-24 px-4" data-id="element-45">
      <div className="max-w-3xl mx-auto" data-id="element-46">
        {/* Guarantee */}
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl border-t-8 border-brand-gold text-center mb-20" data-id="element-47">
          <ShieldCheck className="w-20 h-20 text-brand-gold mx-auto mb-6" data-id="element-48" />
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-gray-900 mb-6 uppercase" data-id="element-49">
            Garantía de Satisfacción de 7 Días
          </h2>
          <p className="text-lg text-gray-700 mb-4" data-id="element-50">
            Estamos tan seguros del valor de este material que puedes probarlo
            sin riesgo.
          </p>
          <p className="text-lg text-gray-700 mb-4" data-id="element-51">
            Si dentro de los primeros 7 días consideras que no te aportó valor,
            solo escríbenos y te devolveremos tu dinero.
          </p>
          <p className="text-xl font-bold text-brand-wine mt-6" data-id="element-52">
            Tu inversión está completamente protegida.
          </p>
        </div>

        {/* FAQ */}
        <div className="mb-20" data-id="element-53">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-center text-gray-900 mb-12" data-id="element-54">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="space-y-4" data-id="element-55">
            {faqs.map((faq, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-56">
                <h3 className="text-xl font-bold text-brand-wine mb-2 flex justify-between items-center" data-id="element-57">
                  {faq.q}
                </h3>
                <p className="text-gray-700 text-lg" data-id="element-58">{faq.a}</p>
              </div>)}
          </div>
        </div>

        {/* Final CTA */}
        <div className="text-center bg-brand-wine text-white rounded-3xl p-8 md:p-16 shadow-2xl relative overflow-hidden" data-id="element-59">
          <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-60"></div>

          <div className="relative z-10" data-id="element-61">
            <h2 className="font-serif text-3xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-62">
              La pregunta no es cuánto cuesta este libro.
            </h2>
            <p className="text-xl md:text-2xl font-medium mb-4 text-brand-gold" data-id="element-63">
              La pregunta es:
            </p>
            <p className="text-2xl md:text-3xl font-bold mb-12" data-id="element-64">
              ¿Cuánto te ha costado seguir conformándote con menos de lo que
              mereces?
            </p>
            <p className="text-lg mb-8 text-white/80" data-id="element-65">
              Haz clic en el botón y comienza hoy el proceso de volver a
              elegirte.
            </p>

            <CTAButton text="QUIERO ACCEDER A MERECES MÁS" microtext="" className="!my-0" data-id="element-66" />
          </div>
        </div>
      </div>
    </section>;
}